import React, { useState } from "react";
import { IconButton, InputAdornment, InputProps, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface IFormIntegerProps {
    value: string;
    maxLength?: number;
    required?: boolean;
    tooltip?: string;
    InputProps?: Partial<InputProps>
    onChange: (value: string) => void;
}

export const FormPassword = (props: IFormIntegerProps) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const handleChange = (event) => {
        const value: string = event.target.value;
        props.onChange(value);
    };

    return (
        <TextField
            type={!showPassword ? "password" : "text"}
            title={props.tooltip}
            value={props.value ?? ""}
            autoComplete="new-password"
            InputProps={{
                ...props.InputProps,
                inputProps: { maxLength: props.maxLength },
                endAdornment:
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={(e) => e.preventDefault()}
                            onMouseUp={(e) => e.preventDefault()}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
            }}
            onChange={handleChange}
        />
    );
};